// Case/InProgressCasesPage.tsx
import { CasesListView } from '../Cases/Components/CasesListView';
import { CASE_STATUS } from '../caseStatusIds';

/** Admin view of every case a leader has accepted and is actively working. */
export default function InProgressCasesPage() {
  return (
    <CasesListView
      fixedStatusID={CASE_STATUS.InProgress}
      title="In Progress Cases"
      subtitle="Cases accepted by a leader and currently being worked"
    />
  );
}
